export default "__VITE_ASSET__c6191e20__"